var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('submenu-page',{attrs:{"eyebrow":"ACADEMIC SERVICES","title":"Learning Management","description":"Create lesson plans, share class notes and manage assignments.","count-label":"learning tools"}},[_c('SubMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }